import { Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
// util
import { containsAllRoles } from "utils/actions";
// pages
import Login from "pages/Login";
import SignUp from "pages/SignUp";
import Home from "pages/Home";
import Profile from "pages/Profile";
//
import Spinner from "utils/Spinner";
//
import { useSelector } from "react-redux";
import HeartScreen from "pages/Profile/HeartScreen.jsx";
import Welcome from "pages/Profile/Welcome";
import Purchase from "pages/Profile/Purchase";
import UserHome from "pages/Profile/UserHome";
import QueryChecker from "utils/queryChecker";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/home" exact element={<Home />} />
      <Route
        exact
        path="/myAccount"
        element={
          <ProtectedRoute redirectPath="/">
            <Profile />
          </ProtectedRoute>
        }
      >
        <Route index exact element={<HeartScreen />} />
        <Route path="welcome" exact element={<Welcome />} />
        <Route path="purchase" exact element={<Purchase />} />
      </Route>
      <Route
        path="/myAccount/home"
        exact
        element={
          <ProtectedRoute redirectPath="/">
            <UserHome />
          </ProtectedRoute>
        }
      />
      <Route exact path="/login" element={<Login />} />
      <Route path="/register" exact element={<SignUp />} />
      <Route
        path="*"
        element={
          <>
            <h4>404 not found</h4>
          </>
        }
      />
    </Routes>
  );
};

// protected route also role base route
const ProtectedRoute = ({ redirectPath = "/", children }) => {

    const withQuery = QueryChecker(["promo","email","sId"]);
  const { isAuthenticated, isLoading } = useSelector(
    (store) => store.auth
  );
  let location = useLocation();
  if (isLoading) {
    return (
      <div className="cs_container h_100 d_flex flex_col align_items_center justify_content_center text_center text_white">
        <Spinner />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to={redirectPath+withQuery} replace state={{ from: location }} />;
  }
  return children ? children : <Outlet />;
};

export default AppRouter;
